export const SpaceLabelService = Symbol('SpaceLabelService');
